import DomainResource from './DomainResource';
import merge from 'lodash/merge';
import Coding from './types/Coding';
import Reference from './types/Reference';

/**
 * One funder's standard authorization, copied into the Add authorization dialog when chosen.
 * `payer` has the shape of Coverage.payor[0] ({ uri, display }); `services` are
 * healthcare-service codings, the shape the dialog stores on a ClaimResponse item.
 */
export default class BN_AuthorizationTemplate extends DomainResource {
    static __className = 'BN_AuthorizationTemplate';

    __objectStructure = {
        name: String,
        active: Boolean,
        payer: Reference,
        services: [Coding],
        allowedUnits: Number,
        allowedDollarAmount: Number,
        durationDays: Number,
    };

    constructor(constructJson, className = 'BN_AuthorizationTemplate') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
